import gameData from "../../gameData.js";
import trayBaseSlider from "./trayBaseSlider.js";

export default class PatternTray extends trayBaseSlider
{
    constructor(scene, parentCont, type, ind)
    {
        super(scene, parentCont, type, ind);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type;
        this.ind = ind;

        this.createPatternTray();

        this.setPosition(0, 0);
        this.scene.addToParent(this, this.pCont);
    }

    createPatternTray()
    {
        for(let i=1;i<=6;i++){
            let pattern = this.scene.addButton(0, 0, "Btn_Pattern"+i, null, ()=>{
                this.scene.playSound("select_color_pattern_face");
                
                gameData.bgColor = null;

                this.scene.navbar.clearActiveTrays();
                this.isActive = true;

                this.scene.faceMask.setFace();
                this.scene.faceMask.setPattern(pattern.id);
                
                this.tweenInCursor(pattern);
            });
            pattern.id = i-1;
            pattern.x = 55;
            pattern.y = -440 + (118*i);

            this.addAt(pattern, 0);
            this.accessories.push(pattern);
        }
    }

    cleanUp()
    {
        this.cursor.destroy();
        this.accessories.forEach(pattern => {pattern.destroy();});
        this.nameplate.destroy();
        this.nameplateText.destroy();
    }
}